import { Bell, ListChecks, Menu, Search, Plus, Users, UserCog, Boxes, Moon, Sun } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const TopBar = ({
  searchQuery,
  onSearch,
  onAddCompany,
  onAddBusiness,
  onAddProject,
  onAddTeamMember,
  onOpenNotifications,
  onOpenUsers,
  onGoToOps,
  onGoToTasks,
  onAddOpsSite,
  onToggleSidebar,
  hasCompanies,
  hasBusinesses,
  notificationCount = 0,
  canManageUsers = false,
  canManageTeam = false,
  canEdit = false,
  onToggleTheme,
  theme = "light",
}) => (
  <header className="topbar" data-testid="topbar">
    <div className="topbar-search">
      <button className="mobile-nav-toggle" onClick={onToggleSidebar} type="button">
        <Menu size={18} />
      </button>
      <div className="relative flex-1">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
        <Input
          type="text"
          placeholder="Search companies, businesses, projects..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          className="pl-10 bg-zinc-50 border-zinc-200 focus:border-zinc-900 rounded-none text-sm"
        />
      </div>
    </div>
    <div className="topbar-actions">
      <Button className="topbar-action-button rounded-none border-zinc-300" onClick={onToggleTheme} type="button" variant="outline">
        {theme === "dark" ? <Sun size={14} className="mr-2" /> : <Moon size={14} className="mr-2" />} {theme === "dark" ? "Light" : "Dark"}
      </Button>
      <Button className="topbar-action-button rounded-none border-zinc-300" onClick={onGoToTasks} type="button" variant="outline">
        <ListChecks size={14} className="mr-2" /> Tasks
      </Button>
      <Button className="topbar-action-button rounded-none border-zinc-300" onClick={onGoToOps} type="button" variant="outline">
        <Boxes size={14} className="mr-2" /> Operations
      </Button>
      <Button className="topbar-action-button rounded-none border-zinc-300 relative" onClick={onOpenNotifications} type="button" variant="outline">
        <Bell size={14} className="mr-2" /> Alerts
        {notificationCount ? <span className="ml-2 inline-flex min-w-5 justify-center rounded-full bg-zinc-900 px-1.5 py-0.5 text-[10px] font-bold text-white">{notificationCount}</span> : null}
      </Button>
      {canManageTeam ? <Button className="topbar-action-button rounded-none border-zinc-300" onClick={onAddTeamMember} type="button" variant="outline"><Users size={14} className="mr-2" /> Team</Button> : null}
      {canManageUsers ? (
        <Button className="topbar-action-button rounded-none border-zinc-300" onClick={onOpenUsers} type="button" variant="outline">
          <UserCog size={14} className="mr-2" /> Users
        </Button>
      ) : null}
      {canEdit ? <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="topbar-primary-action bg-zinc-900 text-white hover:bg-zinc-800 rounded-none px-4 py-2 text-xs font-bold uppercase tracking-wider">
            <Plus size={14} className="mr-2" /> Add New
          </Button>
        </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem onClick={onAddCompany}><span className="font-medium">Company</span></DropdownMenuItem>
            <DropdownMenuItem onClick={onAddBusiness} disabled={!hasCompanies}><span className={!hasCompanies ? "text-zinc-400" : "font-medium"}>Business</span></DropdownMenuItem>
            <DropdownMenuItem onClick={onAddProject} disabled={!hasBusinesses}><span className={!hasBusinesses ? "text-zinc-400" : "font-medium"}>Project</span></DropdownMenuItem>
            <DropdownMenuItem onClick={onAddOpsSite} disabled={!hasBusinesses}><span className={!hasBusinesses ? "text-zinc-400" : "font-medium"}>Operations Site</span></DropdownMenuItem>
            {canManageTeam ? <DropdownMenuItem onClick={onAddTeamMember}><span className="font-medium">Team Member</span></DropdownMenuItem> : null}
          </DropdownMenuContent>
      </DropdownMenu> : null}
    </div>
  </header>
);
